<header class="navbar bg-base-300">

    <div class="max-w-(--breakpoint-2xl) w-full lg:px-10 px-4 mx-auto flex justify-between items-center">
        <div class="flex-none">
            <label for="hamburgerMenu" [attr.aria-label]="'Layout.header.open_menu' | transloco" class="btn btn-square btn-ghost">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                    class="inline-block h-6 w-6 stroke-current" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16">
                    </path>
                </svg>
            </label>
        </div>

        <div class="mx-2 flex-1 px-2 font-semibold">{{ 'Layout.header.title' | transloco }}</div>
        <div class="flex flex-row items-center gap-2 sm:gap-4">
            <label class="swap swap-rotate btn btn-ghost btn-circle">
                <input type="checkbox" class="theme-controller" value="rentdesk-dark" [checked]="themeService.isDark()"
                    (change)="themeService.toggle()" [attr.aria-label]="'Layout.header.toggle_theme' | transloco" />
                <ng-icon class="swap-off" name="tablerSun" size="24" aria-hidden="true" />
                <ng-icon class="swap-on" name="tablerMoon" size="24" aria-hidden="true" />
            </label>
            <div class="dropdown dropdown-end">
                <div tabindex="0" role="button" class="btn btn-ghost h-auto min-h-12 gap-2 px-2"
                    [attr.aria-label]="'Layout.header.user_menu' | transloco">
                    @if (url) {
                        <div class="avatar">
                            <div class="w-10 rounded-full">
                                <img [src]="url" [alt]="name" />
                            </div>
                        </div>
                    } @else {
                        <div class="avatar avatar-placeholder">
                            <div class="bg-neutral text-neutral-content w-10 rounded-full">
                                <span>{{ initials }}</span>
                            </div>
                        </div>
                    }
                    <span class="whitespace-nowrap hidden lg:block">{{ name }}</span>
                </div>
                <ul tabindex="-1" class="menu dropdown-content bg-base-100 rounded-box z-1 mt-3 w-52 p-2 shadow">
                    <li>
                        <a routerLink="/user-configuration" (click)="resetSelections()">
                            <ng-icon name="tablerSettings" size="20" aria-hidden="true" />
                            {{ "Layout.header.settings" | transloco }}
                        </a>
                    </li>
                    <li>
                        <a routerLink="/billing" (click)="resetSelections()">
                            <ng-icon name="tablerCreditCard" size="20" aria-hidden="true" />
                            {{ "Layout.header.billing" | transloco }}
                        </a>
                    </li>
                    <li>
                        <button type="button" (click)="logout()">
                            <ng-icon name="tablerLogout" size="20" aria-hidden="true" />
                            {{ "Layout.header.logout" | transloco }}
                        </button>
                    </li>
                </ul>
            </div>
        </div>
    </div>

</header>
